<template>
  <div class="flex flex-row">
    <text-input
      v-model="clipboardText"
      class="mr-2"
      :readonly="true"
      value="clipboardText"
      :select-all="true"
    />
    <gd-button
      v-clipboard:copy="value"
      v-clipboard:success="onCopy"
      v-clipboard:error="onError"
      size="icon"
      primary
    >
      <i class="fa fa-copy" />
    </gd-button>
  </div>
</template>


<script>
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
import Notify from '@groovepages/gd-lib/notify';
import debounce from 'lodash.debounce';
import mixins from '../mixins';
import TextInput from './TextInput';
import GdButton from './Button';

Vue.use(VueClipboard);

export default {
  name: 'InputWithClipboard',
  inheritAttrs: false,
  mixins: [mixins],
  props: ['value', 'placeholder', 'dark'],
  components: {
    GdButton,
    TextInput,
  },
  data() {
    return {
      clipboardText: this.value,
    };
  },
  methods: {
    onCopy() {
      Notify.success(this.$t('frontend_copied_to_clipboard'));
    },
    onError() {
      Notify.fail(this.$t('frontend_copied_failed_clipboard'));
    },
  },
};
</script>
